import { useWeather } from '@/hooks/useWeather';
import { WeatherSceneView } from './WeatherSceneView';

export function WeatherScene() {
  const { weather } = useWeather();

  if (!weather) {
    return (
      <div
        className="weather-scene"
        style={{ background: '#0E1252' }}
      />
    );
  }

  return <WeatherSceneView weather={weather} />;
}
